import React, { useState, useEffect, useRef } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CheckIcon from '@mui/icons-material/CheckRounded';
import ClearIcon from '@mui/icons-material/ClearRounded';
import {setFormValueByElement} from '../../../utils/Utils'

export default function TextAreaFieldForm(props) {
    const defaultValue = props.defaultValue || '';
    const [value, setValue] = useState(defaultValue);
    const valueRef = useRef()
    
    const saveHandler = () => {
        props.onSave(value);
        setValue(defaultValue);
    }
    
    const cancelHandler = () => {
        setValue(defaultValue);
        valueRef.current.value = defaultValue;
    }
    
    useEffect(() => {
        setFormValueByElement(valueRef.current, defaultValue);
    }, [defaultValue]);
        
    return (
        <Stack direction="row" spacing={1}>
            <TextField
                sx={{width:'100%'}}
                variant="filled"
                label={props.label}
                type="text"
                multiline
                rows={props.rows ? props.rows : 4}
                defaultValue=""
                inputRef={valueRef}
                onInput={(e) => {setValue(e.target.value)}}
            />           
            {value != defaultValue ?
            <Stack direction="row" sx={{paddingTop:1.5, marginBottom:-1.5}}>
                <IconButton color="success" size="medium" onClick={saveHandler}>
                    <Tooltip title="Save">
                        <CheckIcon />
                    </Tooltip>
                </IconButton>
                <IconButton color="warning" size="medium" onClick={cancelHandler}>
                    <Tooltip title="Cancel">
                        <ClearIcon />
                    </Tooltip>
                </IconButton>
            </Stack>
            : null }
        </Stack>
    );
}